import { Route, Routes } from 'react-router-dom';
import './App.css';
import { Navbar, Footer} from './Components/NavbarFooter';
import HomePage from './Pages/HomePage';
import AboutPage from './Pages/AboutPage';
import ReportsRoutes from "./Pages/ReportsPages";
import GrantsRoutes from './Pages/GrantsPages';
// import NewsRoutes from './Pages/NewPages';
import SupportersPage from './Pages/SupportersPage';
import GalleryPage from './Pages/GalleryPage';
import ContactPage from './Pages/ContactPage';
import PrivacyPolicyPage from './Pages/PrivacyPolicyPage';
import IndividualSupport   from "./Pages/IndividualSupport";
import SupportResult       from "./Pages/SupportResult";
import ScrollTopButton from './Components/ScrollToTopButton';
import TermsPage from './Pages/TermsPage';
import SupportCancel from './Pages/SupportCancel';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path='/' element={<HomePage/>} />
        <Route path='/about' element={<AboutPage/>} />
        <Route path='/reports/*' element={<ReportsRoutes/>} />
        <Route path='/grants/*' element={<GrantsRoutes />} />
        {/* <Route path='/news/*' element={<NewsRoutes />} /> */}
        <Route path='/supporters' element={<SupportersPage />} />
        <Route path='/gallery' element={<GalleryPage />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
        <Route path='/terms-of-use' element={<TermsPage />} />
        <Route path="/support" element={<IndividualSupport />} />
        <Route path="/support-thanks" element={<SupportResult type="success" />} />
        <Route path="/support-error"  element={<SupportResult type="error"   />} />
        <Route path='/support-cancel' element={<SupportCancel />} />
      </Routes>
      <Footer />
      <ScrollTopButton />
    </>
  );
}
export default App;